__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "inpl-app-mfe-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("i18next", "26.3.6", () => (() => (__webpack_require__(82526))), 1);
			register("oidc-client-ts", "3.5.0", () => (() => (__webpack_require__(53658))), 1);
			register("react-dom/client", "19.2.0", () => (() => (__webpack_require__(5338))), 1);
			register("react-dom", "19.2.0", () => (() => (__webpack_require__(40961))), 1);
			register("react-i18next", "17.0.11", () => (() => (__webpack_require__(11220))), 1);
			register("react-oidc-context", "3.3.1", () => (() => (__webpack_require__(58944))), 1);
			register("react", "19.2.0", () => (() => (__webpack_require__(96540))), 1);
			register("single-spa-react", "6.0.2", () => (() => (__webpack_require__(64103))), 1);
			register("single-spa", "6.0.3", () => (() => (__webpack_require__(36158))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};